import React from 'react';
import { Text } from '@react-three/drei';

const DebugGrid = ({ visible = true }) => {
    const rows = 16;
    const cols = 8;
    const width = 22;
    const length = 40;
    const startX = -width / 2;
    const startZ = -length / 2;
    const stepX = width / cols;
    const stepZ = length / rows;

    const cells = [];
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            const num = r * cols + c + 1;
            const x = startX + c * stepX + stepX / 2;
            const z = startZ + r * stepZ + stepZ / 2;
            cells.push(
                <Text
                    key={num}
                    position={[x, 0.1, z]}
                    rotation={[-Math.PI / 2, 0, 0]}
                    fontSize={1}
                    color="#FFFF00"
                    anchorX="center"
                    anchorY="middle"
                >
                    {num}
                </Text>
            );
        }
    }

    return <group visible={visible}>{cells}</group>;
};

export default DebugGrid;
